import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const forgePlugin = createPlugin({
  id: "forge",
  routes: {
    root: rootRouteRef,
  },
});

export const ForgePage = forgePlugin.provide(
  createRoutableExtension({
    name: "ForgePage",
    component: () =>
      import("./components/ForgeComponent").then((m) => m.ForgeComponent),
    mountPoint: rootRouteRef,
  })
);

export const ForgeTeamsPage = forgePlugin.provide(
  createComponentExtension({
    name: "ForgeTeamsPage",
    component: {
      lazy: () =>
        import("./components/ForgeComponent/TeamsView").then(
          (m) => m.TeamsView
        ),
    },
  })
);

export const ForgeTeamPage = forgePlugin.provide(
  createComponentExtension({
    name: "ForgeTeamPage",
    component: {
      lazy: () =>
        import("./components/ForgeComponent/TeamView").then((m) => m.TeamView),
    },
  })
);

export const ForgeOverallPage = forgePlugin.provide(
  createComponentExtension({
    name: "ForgeOverallPage",
    component: {
      lazy: () =>
        import("./components/ForgeComponent/OverallView").then(
          (m) => m.OverallView
        ),
    },
  })
);
